import axios from "../axios";

const examinerName = () => localStorage.getItem("UserName") || "Evaluator";

export const osmApi = {
  // 1. Upload (FormData)
  uploadScript: async (file, studentId, assessmentId) => {
    const form = new FormData();
    form.append("osmAnswerBook", file);
    form.append("studentId", studentId);
    form.append("assessmentId", assessmentId);
    form.append("name", file.name);

    const res = await axios.post("/api/v1/osm/scripts/upload", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },

  // 2. List Scripts
  listScripts: async (query = {}) => {
    const res = await axios.get("/api/v1/osm/scripts", { params: query });
    return res.data;
  },

  // 🚀 3. GET SCRIPT (YEH MISSING THA, AB ADD HO GAYA)
  getScript: async (scriptId) => {
    const res = await axios.get(`/api/v1/osm/scripts/${scriptId}`);
    return res.data.data;
  },

  // 4. Get Paper Scheme
  getPaperScheme: async (scriptId) => {
    const res = await axios.get(`/api/v1/osm/scripts/${scriptId}/paper`);
    return res.data.data;
  },

  // 5. Original PDF URL
  getOriginalPdfUrl: async (scriptId) => {
    const res = await axios.get(`/api/v1/osm/scripts/${scriptId}/original-url`);
    return res.data.data.url;
  },

  getPdfBlob: async (url, signal) => {
    const response = await fetch(url, {
      method: "GET",
      mode: "cors",
      credentials: "omit",
      signal,
    });

    if (!response.ok) {
      throw new Error(`PDF download failed: HTTP ${response.status}`);
    }

    return await response.arrayBuffer();
  },

  // 7. Marking Data
  getMarking: async (scriptId) => {
    const res = await axios.get(`/api/v1/osm/scripts/${scriptId}/marking`);
    return res.data.data;
  },

  // 8. Save Marking
  putMarking: async (scriptId, doc) => {
    const res = await axios.put(`/api/v1/osm/scripts/${scriptId}/marking`, doc);
    return res.data.data;
  },

  // 9. Submit
  submit: async (scriptId, version, gradedPdfBlob) => {
    const form = new FormData();
    form.append("osmGradedBook", gradedPdfBlob, "graded.pdf");
    form.append("version", version);

    const res = await axios.post(
      `/api/v1/osm/scripts/${scriptId}/submit`,
      form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return res.data;
  },

  getGradedPdfUrl: async (scriptId) => {
    const res = await axios.get(`/api/v1/osm/scripts/${scriptId}/graded-url`);
    return res.data.data.url;
  },

  reopen: async (scriptId, reason) => {
    const res = await axios.post(`/api/v1/osm/scripts/${scriptId}/reopen`, {
      reason,
    });
    return res.data.data;
  },

  getAudit: async (scriptId) => {
    const res = await axios.get(`/api/v1/osm/scripts/${scriptId}/audit`);
    return res.data.data || [];
  },

  getOriginalPdfBytes: async (scriptId) => {
    const res = await axios.get(
      `/api/v1/osm/scripts/${scriptId}/pdf/original`,
      {
        responseType: "arraybuffer",
      },
    );

    return res.data;
  },

  // Graded PDF through authenticated backend streaming
  getGradedPdfBytes: async (scriptId) => {
    const res = await axios.get(`/api/v1/osm/scripts/${scriptId}/pdf/graded`, {
      responseType: "arraybuffer",
    });

    return res.data;
  },
};
